export default __webpack_public_path__ + "static/media/gallery - story - three brothers (1)_01.a1c36467.jpg";